export const LOCAL_URL = 'http://localhost:3000';
export const DEV_URL = 'https://bartender-dev.com';
export const PROD_LOCAL_URL = 'http://localhost:5000';
